import { BFFRequest, Step, SubmitAnswersRequest } from "../interfaces";
import { ContactOptionEnum } from "../interfaces/IMatchMakerAnswers";
import { 
    VehicleConditionType, 
    FuelType, 
    TransmissionType, 
    VehicleOptionType, 
    AdditionalProductType,
    PhoneCountryCodeType 
} from "@bus/models";

export function mapFromBFFModel(bffResponse: BFFRequest): SubmitAnswersRequest | null {
    try {
        const { data } = bffResponse;
        
        if (!data) {
            return null;
        }

        const { transaction, customerData, dealerData, custom } = data;
        
        // Extract custom step information
        const customData = custom as { step?: Step; SaveAndContinueInfo?: any } | undefined;
        const currentStep = customData?.step || Step.MM1;

        // Map customer preferences back to matchMakerAnswers
        const preferences = customerData?.preferences;
        
        const submitAnswersRequest: SubmitAnswersRequest = {
            transactionId: transaction.id,
            volkswagenGroupPartnerIds: dealerData?.volkswagenGroupPartnerIds || [],
            currentStep: currentStep,
            isEditMode: false,
            matchMakerAnswers: {
                conditions: preferences?.conditions as VehicleConditionType[] | undefined,
                models: preferences?.modelDescriptions,
                fuelTypes: preferences?.fuelTypes as FuelType[] | undefined,
                monthlyPayment: preferences?.budget?.from?.amount,
                hasDeposit: (preferences?.deposit?.amount ?? 0) > 0,
                deposit: preferences?.deposit?.amount,
                duration: preferences?.duration?.value,
                transmissionType: preferences?.transmissions as TransmissionType[] | undefined,
                minPower: preferences?.powerRange?.fromValue,
                maxPower: preferences?.powerRange?.toValue,
                optionals: preferences?.options as VehicleOptionType[] | undefined,
                contractType: preferences?.financialProducts,
                kmsPerYear: preferences?.mileage?.value,
                services: preferences?.services as AdditionalProductType[] | undefined,
            },
        };

        // Add contact details if available
        if (customerData?.firstName && customerData?.lastName) {
            const email = customerData.contactData?.emails?.[0]?.emailAddress;
            const mobilePhoneCountryCode = customerData.contactData?.mobilePhoneCountryCode;
            const mobilePhoneNumber = customerData.contactData?.mobilePhoneNumber;

            if (email && mobilePhoneCountryCode && mobilePhoneNumber) {
                submitAnswersRequest.contactDetails = {
                    firstName: customerData.firstName,
                    lastName: customerData.lastName,
                    email: email,
                    mobilePhoneCountryCode: mobilePhoneCountryCode as PhoneCountryCodeType,
                    mobilePhoneNumber: mobilePhoneNumber,
                    contactPreference: customerData.preferredCommunicationChannel === "EMAIL" 
                        ? ContactOptionEnum.Email 
                        : ContactOptionEnum.Phone,
                };
            }
        }

        // Add selected dealer if available (get first one from volkswagenGroupPartnerIds)
        if (dealerData?.volkswagenGroupPartnerIds && dealerData.volkswagenGroupPartnerIds.length > 0) {
            submitAnswersRequest.selectedDealer = dealerData.volkswagenGroupPartnerIds[0];
        }

        return submitAnswersRequest;
    } catch (error) {
        console.error("Error mapping from BFF model:", error);
        return null;
    }
}
